import { PageableTableProvider } from "../../../../context/PageableTableContext";
import { TableArtworkPrintingTechniqueRequest } from "../../components/ArtworkPrintingTechniquePagableTable";
import { useEffect, useMemo, useState } from "react";
import { TableArtworkCollectionRequest } from "../../components/ArtworkCollectionPagableTable";
import { useGetCollectionsHook } from "../../hooks/useGetCollectionsHook";
import { useGetPrintingTechniqueHook } from "../../hooks/useGetPrintingTechnique";
import { useArtworkApprovalContextStore } from "../../context/approvals/ArtworkApprovalsContext";
import { ArtworkApprovalActions } from "../../state/approvals";
import { ArtworkApprovalRequestTypes } from "../../state/approvals/data.type";
import { useGenericDebounce } from "../../../../hooks/useGenericDebounce";
import { ArtworkApprovalsFilterForm } from "../../components/approvals/filterForm";

export const ApprovalArtwork = () => {
  const [artworkLevel, setArtworkLevel] = useState<
    "collection" | "printingTechnique"
  >("collection");

  const { state, dispatch } = useArtworkApprovalContextStore();

  const handleToggle = (newState: "collection" | "printingTechnique") => {
    setArtworkLevel(newState);
  };

  const searchQueryCollections = useMemo(() => {
    return {
      search: state.collectionFilters.search,
      status: [...state.collectionFilters.status],
      created_by: state.collectionFilters.requestor,
      ordering: state.collectionFilters.lastDays,
      offset: state.collectionFilters.offset,
    };
  }, [
    state.collectionFilters.search,
    ...state.collectionFilters.status,
    state.collectionFilters.requestor,
    state.collectionFilters.lastDays,
    state.collectionFilters.offset,
  ]);
  const searchQueryPrintingTechnique = useMemo(() => {
    return {
      search: state.printingTechniqueFilters.search,
      status: [...state.printingTechniqueFilters.status],
      created_by: state.printingTechniqueFilters.requestor,
      ordering: state.printingTechniqueFilters.lastDays,
      offset: state.printingTechniqueFilters.offset,
    };
  }, [
    state.printingTechniqueFilters.search,
    ...state.printingTechniqueFilters.status,
    state.printingTechniqueFilters.requestor,
    state.printingTechniqueFilters.lastDays,
    state.printingTechniqueFilters.offset,
  ]);

  const { data: collections, isLoading: isCollectionsLoading } =
    useGetCollectionsHook({
      search: searchQueryCollections,
      limit: state.collectionFilters.limit,
    });

  const { data: printingTechnique, isLoading: isPrintingTechniqueLoading } =
    useGetPrintingTechniqueHook({
      search: searchQueryPrintingTechnique,
      limit: state.printingTechniqueFilters.limit,
    });

  useEffect(() => {
    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_COLLECTION_RESULTS,
        collections,
      ),
    );
  }, [collections]);

  useEffect(() => {
    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_PRINTING_TECHNIQUE_RESULTS,
        printingTechnique,
      ),
    );
  }, [printingTechnique]);

  const { debounce } = useGenericDebounce(500);

  const habdleUpdateFilter = (key: any, value: any) => {
    if (artworkLevel === "collection") {
      debounce(
        dispatch,
        ArtworkApprovalActions.setStateValue(
          ArtworkApprovalRequestTypes.SET_COLLECTION_FILTERS,
          { ...state.collectionFilters, [key]: value },
        ),
      );
      return;
    }
    if (artworkLevel === "printingTechnique") {
      debounce(
        dispatch,
        ArtworkApprovalActions.setStateValue(
          ArtworkApprovalRequestTypes.SET_PRINTING_TECHNIQUE_FILTERS,
          { ...state.printingTechniqueFilters, [key]: value },
        ),
      );
      return;
    }
  };

  const handleUpdateStatus = (value: any) => {
    if (artworkLevel === "collection") {
      const updatedStatus = state.collectionFilters.status;
      if (state.collectionFilters.status.includes(value)) {
        updatedStatus.splice(updatedStatus.indexOf(value), 1);
      } else {
        updatedStatus.push(value);
      }

      habdleUpdateFilter("status", updatedStatus);
    }
    if (artworkLevel === "printingTechnique") {
      const updatedStatus = state.printingTechniqueFilters.status;
      if (state.printingTechniqueFilters.status.includes(value)) {
        updatedStatus.splice(updatedStatus.indexOf(value), 1);
      } else {
        updatedStatus.push(value);
      }

      habdleUpdateFilter("status", updatedStatus);
    }

  };

  return (
    <>
      <div
        className="container-fluid mt-3 bg-white shadow py-3 rounded-1 d-flex flex-column justify-contnet-between h-100"
        style={{ minHeight: "70vh" }}
      >
        <h6 className="text-primary fw-bold card-header border-0 mb-2">
          Approval Requests
        </h6>

        <>
          <div className="d-flex justify-content-between table-top-container align-items-center">
            {artworkLevel === "collection" && (
              <ArtworkApprovalsFilterForm
                state={state.collectionFilters}
                onUpdateStatus={handleUpdateStatus}
                onUpdateFilter={habdleUpdateFilter}
                onToggleArtworkLevel={handleToggle}
                artworkLevel={artworkLevel}
              />
            )}

            {artworkLevel === "printingTechnique" && (
              <ArtworkApprovalsFilterForm
                state={state.printingTechniqueFilters}
                onUpdateStatus={handleUpdateStatus}
                onUpdateFilter={habdleUpdateFilter}
                onToggleArtworkLevel={handleToggle}
                artworkLevel={artworkLevel}
              />
            )}
          </div>
          <PageableTableProvider>
            {artworkLevel === "collection" && (
              <TableArtworkCollectionRequest
                collections={collections}
                isLoading={isCollectionsLoading}
              />
            )}
            {artworkLevel === "printingTechnique" && (
              <TableArtworkPrintingTechniqueRequest
                printingTechnique={printingTechnique}
                isPrintingTechniqueLoading={isPrintingTechniqueLoading}
              />
            )}
          </PageableTableProvider>
        </>
      </div>
    </>
  );
};
